import React from 'react';
import './style.css';

export const LoadingIcon = ({ loading, classNames, style }) => {
    return (
        <div style={style} className="loading-icon">
        {
            loading ?
                <div className="spinner-icon">
                    <div className="bounce1" />
                    <div className="bounce2" />
                    <div className="bounce3" />
                </div>
                : null
        }
        </div>
    );
};

export default LoadingIcon;